// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import VueI18n from "vue-i18n";
// import enLocale from "element-ui/lib/locale/lang/en";
// import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import zh from "./lang/zh";
import en from "./lang/en";
import "animate.css";
import "wowjs/css/libs/animate.css";

Vue.config.productionTip = false;

Vue.use(VueI18n);

// const message = {
//   en: {
//     ...en,
//     ...enLocale,
//   },
//   zh: {
//     ...zh,
//     ...zhLocale,
//   },
// };
const i18n = new VueI18n({
  locale: localStorage.getItem("dados_env") || "zh",
  messages: {
    zh: zh,
    en: en,
  },
});
/* eslint-disable no-new */
// new Vue({
//   el: "#app",
//   router,
//   i18n,
//   components: {
//     App,
//   },
//   template: "<App/>",
// });

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js